export const homeworkComponents = ['quiz', 'homeworkAssignment', 'homeworkPractice']